module.exports = __webpack_public_path__ + "img/Pavo.4396cb64.png";